import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";

import { HvButton, HvInput } from "@hitachivantara/uikit-react-core";
import { Add } from "@hitachivantara/uikit-react-icons";

import IncidentTypeFilter from "../IncidentTypeFilter";

import useStyles from "./styles";

interface TableControls {
  onSearch: (value: string) => void;
  onFilter: (value: string[][]) => void;
}

type TableControlProps = TableControls;

const IncidentTypeTableControls: React.FC<TableControlProps> = ({
  onSearch,
  onFilter,
}) => {
  const { t } = useTranslation("common");
  const history = useHistory();
  const { url } = useRouteMatch();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HvInput
        className={classes.inputPlaceholder}
        aria-label={t("common:search.ariaLabel")}
        placeholder={t("common:search.placeholder")}
        type="search"
        onEnter={(event, value) => onSearch?.(value)}
      />
      <IncidentTypeFilter onChange={onFilter} />
      <HvButton
        className={classes.add}
        category="semantic"
        startIcon={<Add />}
        onClick={() => history.push(`${url}/add`)}
      >
        {t("common:buttons.add")}
      </HvButton>
    </div>
  );
};

export default IncidentTypeTableControls;
